import * as React from "react";

const VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

async function fetchVersion() {
  const response = await fetch(`/version.json?t=${Date.now()}`, {
    cache: "no-store",
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch version.json: ${response.status}`);
  }
  const data = await response.json();
  return data.version;
}

export default function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = React.useState(false);
  const runningVersionRef = React.useRef(null);

  React.useEffect(() => {
    let cancelled = false;

    const checkVersion = async () => {
      try {
        const version = await fetchVersion();
        if (cancelled || !version) {
          return;
        }
        if (runningVersionRef.current === null) {
          runningVersionRef.current = version;
        } else if (version !== runningVersionRef.current) {
          setUpdateAvailable(true);
        }
      } catch (error) {
        // Version file unavailable (e.g. dev server without the file) — skip.
      }
    };

    checkVersion();
    const intervalId = window.setInterval(
      checkVersion,
      VERSION_CHECK_INTERVAL_MS,
    );
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkVersion();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const reload = React.useCallback(() => {
    window.location.reload();
  }, []);

  return { updateAvailable, reload };
}
